import { healthSchema, type Health } from '../../shared/contracts/common.ts';
import { parseJsonResponse } from './api-client.ts';

export type { Health } from '../../shared/contracts/common.ts';

export async function getHealth(
  fetcher: typeof fetch = fetch,
): Promise<Health> {
  const response = await fetcher('/api/health');

  return parseJsonResponse(response, healthSchema, 'Health request failed');
}
